import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { FoodItem } from '../types/nutrition';

export interface MealTemplate {
  id: string;
  name: string;
  type: string;
  foods: FoodItem[];
  calories: number;
  protein: number;
  carbs: number;
  fat: number;
}

interface TemplateState {
  templates: MealTemplate[];
  addTemplate: (template: Omit<MealTemplate, 'id'>) => void;
  removeTemplate: (id: string) => void;
  updateTemplate: (id: string, template: Partial<MealTemplate>) => void;
  getTemplatesByType: (type: string) => MealTemplate[];
}

export const useTemplateStore = create<TemplateState>()(
  persist(
    (set, get) => ({
      templates: [],
      
      addTemplate: (template) => {
        const id = crypto.randomUUID();
        set((state) => ({
          templates: [...state.templates, { ...template, id }]
        }));
      },
      
      removeTemplate: (id) => {
        set((state) => ({
          templates: state.templates.filter((t) => t.id !== id)
        }));
      },
      
      updateTemplate: (id, updates) => {
        set((state) => ({
          templates: state.templates.map((t) =>
            t.id === id ? { ...t, ...updates } : t
          )
        }));
      },
      
      getTemplatesByType: (type) => {
        return get().templates.filter((t) => t.type === type);
      }
    }),
    {
      name: 'meal-templates',
      version: 1
    }
  )
);